import clsx from "clsx";
import moment from "moment";
import { useEffect, useState } from "react";

/* eslint-disable-next-line */
export interface LCountDownTimerProps {
  endDate: Date;
  description?: string;
  hasArrowDownImage?: boolean;
  hideArrowOnMobile?: boolean;
}

export function LCountDownTimer(props: LCountDownTimerProps) {
  const [countdown, setCountdown] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  }>();

  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment();
      const end = moment(props?.endDate);
      const diff = end.diff(now);

      const duration = moment.duration(diff);
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      setCountdown({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [props?.endDate]);

  return (
    <div>
      {Number(countdown?.seconds) > -1 && (
        <div className="flex flex-col lg:items-center lg:flex-row">
          <div className="flex flex-col gap-5">
            <div className="flex flex-row items-center justify-center gap-3 mx-auto lg:justify-start">
              <div className="flex flex-col items-center justify-center w-16 h-16 text-center rounded-full bg-eklight lg:w-20 lg:h-20">
                <div className="text-2xl font-extrabold lg:text-3xl text-ekdeepred">
                  {countdown?.days}
                </div>
                <div className="text-sm text-ekblue">Zile</div>
              </div>
              <div>:</div>
              <div className="flex flex-col items-center justify-center w-16 h-16 text-center rounded-full bg-eklight lg:w-20 lg:h-20">
                <div className="text-2xl font-extrabold lg:text-3xl text-ekdeepred">
                  {countdown?.hours}
                </div>
                <div className="text-sm text-ekblue">Ore</div>
              </div>
              <div>:</div>
              <div className="flex flex-col items-center justify-center w-16 h-16 text-center rounded-full bg-eklight lg:w-20 lg:h-20">
                <div className="text-2xl font-extrabold lg:text-3xl text-ekdeepred">
                  {countdown?.minutes}
                </div>
                <div className="text-sm text-ekblue">Min</div>
              </div>
              <div>:</div>
              <div className="flex flex-col items-center justify-center w-16 h-16 text-center rounded-full bg-eklight lg:w-20 lg:h-20">
                <div className="text-2xl font-extrabold lg:text-3xl text-ekdeepred">
                  {countdown?.seconds}
                </div>
                <div className="text-sm text-ekblue">Sec</div>
              </div>
            </div>
            {props?.description && (
              <div className="timer-description">{props?.description}</div>
            )}
          </div>
          {props?.hasArrowDownImage && (
            <div
              className={clsx([
                props?.hideArrowOnMobile && "hidden lg:block",
                "self-end -mt-10 -mb-10 lg:-mb-10 lg:-ml-10",
              ])}
            >
              <img src="/img/arrow-red-down.svg" alt="sageata rosie jos" />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default LCountDownTimer;
